export default __webpack_public_path__ + "fonts/5755ea3780028b868b125c2c38560caa.woff";